'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$103() {
  this.bco = null;
  this.bcp = false;
}
export { $c_Lpresto_PrestoRouter$$anon$103 as $c_Lpresto_PrestoRouter$$anon$103 };
$p = $c_Lpresto_PrestoRouter$$anon$103.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$103;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$103() {
}
export { $h_Lpresto_PrestoRouter$$anon$103 as $h_Lpresto_PrestoRouter$$anon$103 };
$h_Lpresto_PrestoRouter$$anon$103.prototype = $p;
$p.bY = (function() {
  if ((!this.bcp)) {
    this.bco = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bcp = true;
  }
  return this.bco;
});
$p.P = (function() {
  return this.bY();
});
var $d_Lpresto_PrestoRouter$$anon$103 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$103, "presto.PrestoRouter$$anon$103", ({
  NA: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$103 as $d_Lpresto_PrestoRouter$$anon$103 };
//# sourceMappingURL=presto.-Presto-Router$$anon$103.js.map
